import { Field, RadioGroup } from 'Components/Core';
import withInjectedProps from 'Components/Core/InjectedPropsContext/withInjectedProps';
import ListFieldSection from 'Components/Layout/FieldSection/ListFieldSection';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import React from 'react';
import { WashingMethod } from '../../types';

let AsPreparationWetSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Wet Preparation">
        <Field
          input={<RadioGroup />}
          name="WashingMethod"
          options={[
            { label: 'Full wash (with drying)', value: WashingMethod.FullWash },
            { label: 'Spray wash (no drying)', value: WashingMethod.SprayWash },
          ]}
        ></Field>
      </ListFieldSection>
    </>
  );
};

AsPreparationWetSection = withInjectedProps(AsPreparationWetSection);

export { AsPreparationWetSection };
export default AsPreparationWetSection;
